import React from "react";
import { replaceQuotationMarksWithGuillemets } from "../../util/format/guillemets";
const PageSectionHeading = _ref => {
    let { title, textColor, className } = _ref;
    const color = textColor ? textColor : "makroOrange";
    return /*#__PURE__*/ React.createElement("div", {
        className: `block w-full text-xl text-${color} uppercase ${className || ""}`
    }, replaceQuotationMarksWithGuillemets(title));
};
export default PageSectionHeading;
